import {ShoppingContext, util, ConfigService} from '@nuskin/ns-util';
import axios from 'axios';

const SIGNUP_CHANNELS = new Map([
    [ShoppingContext.PERSONAL_OFFER, {guest: 'MEP', normal: 'MPS'}],
    [ShoppingContext.STOREFRONT, {guest: 'MES', normal: 'MSS'}],
    [ShoppingContext.SKIN_CONSULT, {guest: 'VGC', normal: 'VSC'}]
]);

export function getSignupChannel({isGuest}) {
    let {context} = ShoppingContext.getShoppingContext() || {};

    // Todo remove this default block after shopping context is turned on
    // When there is no shopping context we need to check for personal offer or storefront the old way
    if (!SIGNUP_CHANNELS.has(context)) {
        if (util.isPersonalOffer()) {
            context = ShoppingContext.PERSONAL_OFFER;
        } else if (util.getSponsorId()) {
            context = ShoppingContext.STOREFRONT
        }
    }

    const channelInfo = SIGNUP_CHANNELS.get(context);
    if (!channelInfo) {
        return '';
    }

    return isGuest ? channelInfo.guest : channelInfo.normal;
}

export async function isUsernameAvailable(username) {
    const _config = ConfigService.getMarketConfig();
    let client_id = _config.checkout.clientId;
    let awsUrl = _config.awsUrl;
    
    const config = {
        method: 'get',
        url: `${awsUrl}/account-util-proxy/v1/account/username-ck?login=${username}`,
        headers: { 
            client_id
        }
    };
    
    try{
        const response = await axios(config);
        if(response && response.data) {
            return response.data.available;
        }
    }catch(error){
        console.log((error.response || {}).data)
    }
}
